module.exports = __webpack_public_path__ + "img/waistband elastic width.adb8f279.png";